import {
    isAlphaNumericKey,
    isNumpadNumericKey,
    keyCodes,
    TextCellTemplate,
} from "@silevis/reactgrid";
import ContextMenuCellWrapper from "./ContextMenuCellWrapper";
import HighlightCell from "./HighlightCell";
import { useState } from "react";

export class CustomTextCellTemplate {
    constructor() {
        this.base = new TextCellTemplate();
    }

    getStyle() {
        return {
            overflow: "visible",
        };
    }

    getCompatibleCell(cell) {
        return this.base.getCompatibleCell(cell);
    }

    update(cell, cellToMerge) {
        return this.getCompatibleCell({
            ...cell,
            text: cellToMerge.value.toString(),
            value: cellToMerge.value,
            text: cellToMerge.text,
        });
    }

    handleKeyDown(cell, keyCode, ctrl, shift, alt) {
        if (
            !ctrl &&
            !alt &&
            (isAlphaNumericKey(keyCode) || isNumpadNumericKey(keyCode))
        ) {
            const char = isNumpadNumericKey(keyCode)
                ? String.fromCharCode(keyCode - 48)
                : String.fromCharCode(keyCode);
            if (char) {
                const updatedCell = this.update(cell, {
                    ...cell,
                    text: char,
                    value: char,
                });
                return {
                    cell: { ...updatedCell, value: updatedCell.value },
                    enableEditMode: true,
                };
            }
        }
        return {
            cell: { ...cell, text: cell.text, value: cell.value },
            enableEditMode:
                keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
        };
    }

    render(cell, isInEditMode, onCellChanged) {
        return (
            <TextCell
                base={this.base}
                isInEditMode={isInEditMode}
                onCellChanged={onCellChanged}
                cell={cell}
            />
        );
    }
}

const TextCell = ({ base, isInEditMode, onCellChanged, cell }) => {
    const [hover, setHover] = useState(false);
    const handleMouseEnter = () => {
        setHover(true);
    };
    const handleMouseLeave = () => {
        setHover(false);
    };
    return (
        <ContextMenuCellWrapper cell={cell}>
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    justifyContent: "left",
                    alignItems: "center",
                    display: "flex",
                    overflow: "auto",
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {base.render(cell, isInEditMode, onCellChanged)}
                <HighlightCell hover={hover} cell={cell} />
            </div>
        </ContextMenuCellWrapper>
    );
};
